import axios from "axios"
import reportError from "./interceptors/reportError"

const apiClient = () => {
  const baseURL = process.env.VUE_APP_ACCOUNT_SITE_URL
  const header = {
    "Content-Type": "application/json"
  }

  const api = axios.create({
    baseURL,
    "Cache-Control": "no-cache",
    headers: header
  })

  api.interceptors.response.use(
    response => response,
    error => reportError(error)
  )

  return api
}

export default {
  fetchTariffs(data) {
    return apiClient().post("api/v1/energy_products/fetch_by_postcode", data)
  }
}
